import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

class ErrorAlert extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (

            <Modal
                show={this.props.show} onHide={this.props.onHide} 
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton style={{backgroundColor:"#F7D7DA"}}>
                    <Modal.Title id="contained-modal-title-vcenter" style={{color:"#CC0000"}}>
                        Oh snap! You got an error!
                </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{backgroundColor:"#F7D7DA"}}>
                    <p style={{color:"#CC0000", lineHeight:"30px"}}>
                        Okay, looks like something went wrong here. We are fixing it. You should probably get some coffee/walk and come back.
                    </p>
                </Modal.Body>
                <Modal.Footer style={{backgroundColor:"#F7D7DA"}}>
                    <Button onClick={this.props.onHide} variant="danger">Okay</Button>
                </Modal.Footer>
            </Modal>
        );
    }

}

export default ErrorAlert;